var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isViewOnly)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.nl2br(_vm.value))}}):_c('textarea',{staticStyle:{"box-sizing":"border-box"},domProps:{"value":_vm.value},on:{"input":_vm.onTextChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }